import { render, staticRenderFns } from "./KeyValueDataTable.vue?vue&type=template&id=78827a6a&scoped=true&"
import script from "./KeyValueDataTable.vue?vue&type=script&lang=js&"
export * from "./KeyValueDataTable.vue?vue&type=script&lang=js&"
import style0 from "./KeyValueDataTable.vue?vue&type=style&index=0&id=78827a6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78827a6a",
  null
  
)

export default component.exports